
<template>
 <div class="w-11/12 h-full grid grid-cols-2 space-y-1 bg-indigo-600 rounded-xl">
              <div class=" h-full ">
                <img
                  src="@/assets/images/article-lock.png"
                  class="w-1/3 mx-auto mt-10"
                />
              </div>

              <div class="text-center">


                <div class="mt-6 mx-10 pb-10 text-left w-9/12 text-white">
                  <h2 class="text-3xl text-white font-bold">Upgrade to view</h2>
                  <p class="text-base mt-4">
                    You currently do not have access to this feature or area and
                    will need to upgrade to view its content.
                  </p>
                  <p class="text-base mt-4">
                    Please contact us for further upgrade and access information
                    or notify us directly below.
                  </p>

                  <div
                    v-if="!interestComplete"
                    class="flex justify-between text-center grid grid-cols-2 space-x-6 mt-8 w-11/12 text-sm"
                  >
                    <button
                      @click="processUpgrade('Account Upgrade')"
                      class="block bg-action-blue hover:bg-opacity-50 focus:bg-action-blue focus:bg-opacity-50 text-white font-semibold rounded py-3 px-4"
                    >
                      Upgrade our Account
                    </button>

                    <button
                      @click="registerSignUp('Feature Unlock')"
                      class="block bg-orange-600 bg-opacity-75 hover:bg-opacity-50 focus:bg-action-blue focus:bg-opacity-50 text-white font-semibold rounded py-3 px-4"
                    >
                      Unlock this feature
                    </button>
                  </div>
                  <p class="bg-green-500 text-white p-3 rounded mt-4 text-base font-bold mt-8" v-else>
                    Thank you for registering your upgrade interest. <br />One of our
                    team will be in touch.
                  </p>
                </div>
              </div>
            </div>
</template>

<script>
export default {
  name: "notice",
     props: {
    area: { type: String, required: true },
  },
  data() {
    return {
     interestComplete: false,
    };
  },
  methods: {
       processUpgrade(option) {
      let result = "Upgrade Request \nType: " + option + "\nArea: " +this.area;
      let payload = { content: result };
      SchoolService.create("comms/feature-request", payload)
        .then((response) => this.completion())
        .catch((err) => {
          console.log("Reset error " + err);
        });
    },
    completion() {
      this.interestComplete = true
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
